var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "订单信息",
                visible: _vm.dialogVisible,
                width: "1000px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "description",
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    _vm._l(_vm.baseOption, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.dataIndex,
                          staticClass: "description-term",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                "：\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          item.dataIndex != "statusName"
                            ? _c(
                                "span",
                                {
                                  style:
                                    item.dataIndex == "totalSupplierPrice" ||
                                    item.dataIndex == "userRemark"
                                      ? "color: red;"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          "--"
                                      )
                                  ),
                                  item.dataIndex == "totalSupplierPrice"
                                    ? _c("span", [_vm._v("元")])
                                    : _vm._e(),
                                ]
                              )
                            : _c("span", [
                                _vm.orderDatalist["statusName"] == "部分退款"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#E6A23C" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist[item.dataIndex]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm.orderDatalist["statusName"] ==
                                      "已取消" ||
                                    _vm.orderDatalist["statusName"] == "已关闭"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#909399" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist[item.dataIndex]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm.orderDatalist["statusName"] ==
                                      "待支付" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "处理中" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "退款中" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "售后中" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "部分发货"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#409EFF" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist[item.dataIndex]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm.orderDatalist["statusName"] ==
                                      "已支付" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "已发货" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "已完结" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "退款成功"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#67C23A" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist[item.dataIndex]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm.orderDatalist["statusName"] ==
                                      "退款失败" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "拒绝退款" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "支付失败" ||
                                    _vm.orderDatalist["statusName"] ==
                                      "向第三方下单失败"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#F56C6C" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist[item.dataIndex]
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _vm.orderDatalist.dynamicFormInfo
                    ? [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("表单信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "form-info-card",
                                attrs: { shadow: "hover" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-card-header",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "form-card-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderDatalist.dynamicFormInfo
                                              .title || "表单内容"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-card-meta" },
                                      [
                                        _vm._v(
                                          "\n                  表单ID: " +
                                            _vm._s(
                                              _vm.orderDatalist.dynamicFormId ||
                                                "--"
                                            ) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "form-value-id-meta" },
                                          [
                                            _vm._v(
                                              "表单值ID: " +
                                                _vm._s(
                                                  _vm.orderDatalist
                                                    .dynamicFormValueId || "--"
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "form-card-time" },
                                          [
                                            _vm._v(
                                              "提交时间: " +
                                                _vm._s(
                                                  _vm.orderDatalist
                                                    .dynamicFormInfo
                                                    .submitTime || "--"
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "copy-btn",
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                              icon: "el-icon-document-copy",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyFormData(
                                                  _vm.orderDatalist
                                                    .dynamicFormInfo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("复制表单数据")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.orderDatalist.dynamicFormInfo.formItems &&
                                _vm.orderDatalist.dynamicFormInfo.formItems
                                  .length > 0
                                  ? [
                                      _c(
                                        "el-table",
                                        {
                                          staticClass: "form-table",
                                          attrs: {
                                            data: _vm.orderDatalist
                                              .dynamicFormInfo.formItems,
                                            size: "mini",
                                            "header-cell-style": {
                                              background: "#f5f7fa",
                                              color: "#606266",
                                              fontWeight: "bold",
                                              padding: "12px",
                                            },
                                            "cell-style": { padding: "12px" },
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "title",
                                              label: "字段名称",
                                              "min-width": "150",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                scope.row
                                                                  .title ||
                                                                  "未命名"
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          scope.row.required
                                                            ? _c(
                                                                "el-tag",
                                                                {
                                                                  attrs: {
                                                                    size: "mini",
                                                                    type: "danger",
                                                                  },
                                                                },
                                                                [_vm._v("必填")]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      scope.row.key
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-id",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "ID: " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .key
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2228724776
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "填写内容",
                                              "min-width": "250",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      scope.row.type ===
                                                      "checkbox"
                                                        ? [
                                                            scope.row.value &&
                                                            scope.row.value.startsWith(
                                                              "["
                                                            )
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form-item-tags",
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      _vm.parseFormValue(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      ),
                                                                      function (
                                                                        val,
                                                                        idx
                                                                      ) {
                                                                        return _c(
                                                                          "el-tag",
                                                                          {
                                                                            key: idx,
                                                                            staticClass:
                                                                              "form-tag",
                                                                            attrs:
                                                                              {
                                                                                size: "mini",
                                                                                type: "success",
                                                                                effect:
                                                                                  "plain",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                val
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm.parseFormValue(
                                                                      scope.row
                                                                        .value
                                                                    ).length ===
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "empty-value",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "--"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  2
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatFormValue(
                                                                          scope.row
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                            "radio" ||
                                                          scope.row.type ===
                                                            "select"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      size: "mini",
                                                                      type: "primary",
                                                                      effect:
                                                                        "plain",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "dateSelect"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "date-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .value
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "phone"
                                                        ? [
                                                            scope.row.value
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "phone-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatPhoneNumber(
                                                                          scope
                                                                            .row
                                                                            .value
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "empty-value",
                                                                  },
                                                                  [_vm._v("--")]
                                                                ),
                                                          ]
                                                        : scope.row.type ===
                                                          "textarea"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "textarea-content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .value ||
                                                                    "--"
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : scope.row.value
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .value
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "empty-value",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1583904216
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "类型",
                                              width: "100",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: _vm.getFormItemTagType(
                                                              scope.row.type
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getFormItemTypeName(
                                                                  scope.row.type
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              747218253
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _c("div", { staticClass: "no-form-data" }, [
                                      _c("i", {
                                        staticClass: "el-icon-document",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("暂无表单数据")]),
                                    ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._v("商品明细")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.orderDatalist.orderItemList || [],
                            size: "mini",
                            "highlight-current-row": "",
                            "header-cell-style": { fontWeight: "bold" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuId",
                              label: "skuID",
                              "min-width": "50",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuCode",
                              label: "编号",
                              "min-width": "140",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuName",
                              label: "名称",
                              "min-width": "140",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuAttr",
                              label: "销售属性",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuQuantity",
                              label: "数量",
                              "min-width": "60",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuPrice",
                              label: "结算单价",
                              "min-width": "60",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuTotalPrice",
                              label: "结算总价",
                              "min-width": "60",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skuTotalPrice",
                              label: "图片",
                              "min-width": "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return scope.row.skuImg
                                      ? _c("el-image", {
                                          staticStyle: {
                                            width: "46px",
                                            height: "46px",
                                          },
                                          attrs: {
                                            src: scope.row.skuImg,
                                            "preview-src-list": [
                                              scope.row.skuImg,
                                            ],
                                          },
                                        })
                                      : _vm._e()
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "关联售后", "min-width": "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.aftersaleAndAmount || [],
                                      function (item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item
                                              ? item.afterSaleId
                                              : "no-id",
                                          },
                                          [
                                            item && item.afterSaleId
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navigateToAftersaleDetail(
                                                          item.afterSaleId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.afterSaleId) +
                                                        "-" +
                                                        _vm._s(item.amount) +
                                                        "元"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              1617478999
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  ![2, 3, 10].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("物流信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _c("div", { staticClass: "description-term" }, [
                              _vm._v("\n            物流信息：\n            "),
                              _vm._v(" "),
                              _vm.orderDatalist["deliveryStatusName"] ==
                                "未发货" ||
                              _vm.orderDatalist["deliveryStatusName"] ==
                                "揽收" ||
                              _vm.orderDatalist["deliveryStatusName"] ==
                                "在途" ||
                              _vm.orderDatalist["deliveryStatusName"] ==
                                "派件" ||
                              _vm.orderDatalist["deliveryStatusName"] == "清关"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#409EFF" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist[
                                            "deliveryStatusName"
                                          ]
                                        )
                                      ),
                                    ]
                                  )
                                : _vm.orderDatalist["deliveryStatusName"] ==
                                    "退回" ||
                                  _vm.orderDatalist["deliveryStatusName"] ==
                                    "退签" ||
                                  _vm.orderDatalist["deliveryStatusName"] ==
                                    "疑难" ||
                                  _vm.orderDatalist["deliveryStatusName"] ==
                                    "拒签"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#67C23A" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist[
                                            "deliveryStatusName"
                                          ]
                                        )
                                      ),
                                    ]
                                  )
                                : _vm.orderDatalist["deliveryStatusName"] ==
                                    "虚拟发货" ||
                                  _vm.orderDatalist["deliveryStatusName"] ==
                                    "签收" ||
                                  _vm.orderDatalist["deliveryStatusName"] ==
                                    "转投"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#F56C6C" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDatalist[
                                            "deliveryStatusName"
                                          ]
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.transportOption, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.dataIndex,
                                  staticClass: "description-term",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        item.title +
                                          "：" +
                                          ((_vm.orderDatalist.orderDelivery &&
                                            _vm.orderDatalist.orderDelivery[
                                              item.dataIndex
                                            ]) ||
                                            "--")
                                      ) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.orderDatalist.kuaiDiInfoList || [],
                              function (logisticsInfo, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "description-term",
                                    staticStyle: {
                                      width: "100%",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openLogistics(
                                          logisticsInfo.nu
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t物流信息" +
                                        _vm._s(index + 1) +
                                        "：" +
                                        _vm._s(
                                          logisticsInfo &&
                                            logisticsInfo.data &&
                                            logisticsInfo.data.length
                                            ? logisticsInfo.stateMsg +
                                                " - " +
                                                logisticsInfo.data[0].context +
                                                " - " +
                                                logisticsInfo.data[0].time +
                                                " - 【" +
                                                _vm.getDeliveryName(
                                                  logisticsInfo
                                                ) +
                                                " - " +
                                                logisticsInfo.nu +
                                                "】"
                                            : "--"
                                        ) +
                                        "\n\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [2].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("第三方卡券信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.thirdPartyCouponInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [10].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("点餐信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.diningInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [4].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("家政信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.housekeepingInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.orderDatalist[item.dataIndex] ||
                                          item.uint ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [8].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("蛋糕信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          _vm._l(_vm.cakeInfo, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.dataIndex,
                                staticClass: "description-term",
                                style: item.widthAll ? "width: 100%; " : "",
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(item.title) + "："),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.orderDatalist.storeDetail &&
                                          _vm.orderDatalist.storeDetail[
                                            item.dataIndex
                                          ]) ||
                                          _vm.orderDatalist[item.dataIndex] ||
                                          "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [12].includes(_vm.orderDatalist.type)
                    ? [
                        _c("div", { staticClass: "flex-btw" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("自营卡券信息"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            !_vm.orderDatalist.platformCarmine ||
                            Object.keys(_vm.orderDatalist.platformCarmine)
                              .length === 0
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "description-term",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c("div", { staticClass: "flex" }, [
                                        _c("div", [
                                          _vm._v("暂无卡券信息或卡券尚未生成"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              : _vm._l(
                                  _vm.selfOperatedCouponInfo,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.dataIndex,
                                        staticClass: "description-term",
                                        style: item.widthAll
                                          ? "width: 100%; "
                                          : "",
                                      },
                                      [
                                        _c("div", { staticClass: "flex" }, [
                                          _c(
                                            "div",
                                            { staticClass: "item-title" },
                                            [_vm._v(_vm._s(item.title) + "：")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDatalist
                                                  .platformCarmine[
                                                  item.dataIndex
                                                ] || "--"
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("TransportTrace", { ref: "TransportTraceRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }